import { extendTheme } from '@chakra-ui/react';

// Match portal styles in Chakra dialogs, inputs, and legacy log controls.
const portalTheme = extendTheme({
  fonts: {
    body: 'var(--portal-font)',
    heading: 'var(--portal-font)',
    mono: 'var(--portal-font)',
  },
  colors: {
    orange: {
      50: '#fff7ed',
      100: '#ffedd5',
      200: '#fed7aa',
      300: '#fdba74',
      400: '#fb923c',
      500: '#b45309',
      600: '#92400e',
      700: '#78350f',
      800: '#652d0e',
      900: '#431d09',
    },
  },
  styles: {
    global: {
      body: { bg: 'var(--portal-background)', color: 'var(--portal-text)' },
    },
  },
  components: {
    Button: { baseStyle: { borderRadius: '8px', fontWeight: 600 } },
    Input: { variants: { outline: { field: { borderColor: '#cbd3de', borderRadius: '8px' } } } },
    Modal: { baseStyle: { dialog: { borderRadius: '12px' } } },
  },
});

export default portalTheme;
